module.exports = __webpack_public_path__ + "img/18.070ab3a8.png";